module.exports = __webpack_public_path__ + "img/lms.55b201af.png";